module.exports = __webpack_public_path__ + "img/ic-ic-tr-event.3cc12240.svg";